/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const e = "scheduler.allEvents", r = "scheduler.allDay", t = "scheduler.today", c = "scheduler.timelineViewTitle", n = "scheduler.weekViewTitle", o = "scheduler.workWeekViewTitle", i = "scheduler.agendaViewTitle", d = "scheduler.dayViewTitle", s = "scheduler.monthViewTitle", l = "scheduler.deleteTitle", u = "scheduler.previousTitle", a = "scheduler.nextTitle", E = "scheduler.showFullDay", h = "scheduler.showWorkDay", y = "scheduler.editOccurrence", v = "scheduler.editSeries", T = "scheduler.editRecurringConfirmation", D = "scheduler.editRecurringDialogTitle", f = "scheduler.editSave", m = "scheduler.editCancel", R = "scheduler.editorTitle", k = "scheduler.editorEventTitle", p = "scheduler.editorEventStart", w = "scheduler.editorEventStartTimeZone", W = "scheduler.editorEventEnd", O = "scheduler.editorEventEndTimeZone", S = "scheduler.editorEventAllDay", g = "scheduler.editorEventDescription", F = "scheduler.editorEventSeparateTimeZones", V = "scheduler.editorEventTimeZone", q = "scheduler.recurrenceEditorRepeat", M = "scheduler.recurrenceEditorDailyInterval", Z = "scheduler.recurrenceEditorDailyRepeatEvery", P = "scheduler.recurrenceEditorWeeklyInterval", Y = "scheduler.recurrenceEditorWeeklyRepeatEvery", I = "scheduler.recurrenceEditorWeeklyRepeatOn", A = "scheduler.recurrenceEditorMonthlyDay", C = "scheduler.recurrenceEditorMonthlyInterval", N = "scheduler.recurrenceEditorMonthlyRepeatEvery", b = "scheduler.recurrenceEditorMonthlyRepeatOn", L = "scheduler.recurrenceEditorYearlyOf", x = "scheduler.recurrenceEditorYearlyRepeatEvery", j = "scheduler.recurrenceEditorYearlyRepeatOn", z = "scheduler.recurrenceEditorYearlyInterval", B = "scheduler.recurrenceEditorFrequenciesDaily", G = "scheduler.recurrenceEditorFrequenciesMonthly", H = "scheduler.recurrenceEditorFrequenciesNever", J = "scheduler.recurrenceEditorFrequenciesWeekly", K = "scheduler.recurrenceEditorFrequenciesYearly", Q = "scheduler.recurrenceEditorOffsetPositionsFirst", U = "scheduler.recurrenceEditorOffsetPositionsSecond", X = "scheduler.recurrenceEditorOffsetPositionsThird", _ = "scheduler.recurrenceEditorOffsetPositionsFourth", $ = "scheduler.recurrenceEditorOffsetPositionsLast", ee = "scheduler.recurrenceEditorWeekdaysDay", re = "scheduler.recurrenceEditorWeekdaysWeekday", te = "scheduler.recurrenceEditorWeekdaysWeekendday", ce = "scheduler.recurrenceEditorEndAfter", ne = "scheduler.recurrenceEditorEndOccurrence", oe = "scheduler.recurrenceEditorEndLabel", ie = "scheduler.recurrenceEditorEndNever", de = "scheduler.recurrenceEditorEndOn", se = "scheduler.editorDelete", le = "scheduler.deleteConfirmation", ue = "scheduler.deleteRecurringConfirmation", ae = "scheduler.deleteOccurrence", Ee = "scheduler.deleteSeries", he = "scheduler.deleteDialogTitle", ye = "scheduler.deleteRecurringDialogTitle", ve = "scheduler.dateTitle", Te = "scheduler.timeTitle", De = "scheduler.eventTitle", fe = "scheduler.editorValidationRequired", me = "scheduler.editorValidationStart", Re = "scheduler.editorValidationEnd", ke = "scheduler.noEvents", pe = "scheduler.moreEvents", we = {
  [fe]: "Field is required.",
  [me]: "Start time must be before End time.",
  [Re]: "End time must be after Start time.",
  [e]: "All events",
  [r]: "all day",
  [t]: "Today",
  [d]: "Day",
  [s]: "Month",
  [n]: "Week",
  [o]: "Work Week",
  [c]: "Timeline",
  [i]: "Agenda",
  [l]: "Delete",
  [u]: "Previous",
  [a]: "Next",
  [E]: "Show full day",
  [h]: "Show business hours",
  [y]: "Edit current occurrence",
  [v]: "Edit the series",
  [T]: "Do you want to edit only this event occurrence or the whole series?",
  [D]: "Edit Recurring Item",
  [f]: "Save",
  [m]: "Cancel",
  [se]: "Delete",
  [R]: "Event",
  [k]: "Title",
  [p]: "Start",
  [w]: "Start Time Zone",
  [W]: "End",
  [O]: "End Time Zone",
  [S]: "All Day Event",
  [g]: "Description",
  [F]: "End in different Time Zone",
  [V]: "Specify Time Zone",
  [q]: "Repeat",
  [M]: "day(s)",
  [Z]: "Repeat every",
  [P]: "week(s)",
  [Y]: "Repeat every",
  [I]: "Repeat on",
  [A]: "Day",
  [C]: "month(s)",
  [N]: "Repeat every",
  [b]: "Repeat on",
  [L]: "of",
  [x]: "Repeat every",
  [j]: "Repeat on",
  [z]: "year(s)",
  [B]: "Daily",
  [G]: "Monthly",
  [H]: "Never",
  [J]: "Weekly",
  [K]: "Yearly",
  [Q]: "First",
  [U]: "Second",
  [X]: "Third",
  [_]: "Fourth",
  [$]: "Last",
  [ee]: "Day",
  [re]: "Weekday",
  [te]: "Weekend Day",
  [ce]: "After",
  [ne]: "occurrence(s)",
  [oe]: "End",
  [ie]: "Never",
  [de]: "On",
  [le]: "Are you sure you want to delete this event?",
  [ue]: "Do you want to delete only this event occurrence or the whole series?",
  [ae]: "Delete current occurrence",
  [Ee]: "Delete the series",
  [he]: "Delete Event",
  [ye]: "Delete Recurring Item",
  [ve]: "Date",
  [Te]: "Time",
  [De]: "Event",
  [ke]: "no events",
  [pe]: "More events"
};
export {
  i as agendaViewTitle,
  r as allDay,
  e as allEvents,
  ve as dateTitle,
  d as dayViewTitle,
  le as deleteConfirmation,
  he as deleteDialogTitle,
  ae as deleteOccurrence,
  ue as deleteRecurringConfirmation,
  ye as deleteRecurringDialogTitle,
  Ee as deleteSeries,
  l as deleteTitle,
  m as editorCancel,
  se as editorDelete,
  S as editorEventAllDay,
  g as editorEventDescription,
  W as editorEventEnd,
  O as editorEventEndTimeZone,
  F as editorEventSeparateTimeZones,
  p as editorEventStart,
  w as editorEventStartTimeZone,
  V as editorEventTimeZone,
  k as editorEventTitle,
  y as editorOccurrence,
  T as editorRecurringConfirmation,
  D as editorRecurringDialogTitle,
  f as editorSave,
  v as editorSeries,
  R as editorTitle,
  Re as editorValidationEnd,
  fe as editorValidationRequired,
  me as editorValidationStart,
  De as eventTitle,
  we as messages,
  s as monthViewTitle,
  pe as moreEvents,
  a as nextTitle,
  ke as noEvents,
  u as previousTitle,
  M as recurrenceEditorDailyInterval,
  Z as recurrenceEditorDailyRepeatEvery,
  ce as recurrenceEditorEndAfter,
  oe as recurrenceEditorEndLabel,
  ie as recurrenceEditorEndNever,
  ne as recurrenceEditorEndOccurrence,
  de as recurrenceEditorEndOn,
  B as recurrenceEditorFrequenciesDaily,
  G as recurrenceEditorFrequenciesMonthly,
  H as recurrenceEditorFrequenciesNever,
  J as recurrenceEditorFrequenciesWeekly,
  K as recurrenceEditorFrequenciesYearly,
  A as recurrenceEditorMonthlyDay,
  C as recurrenceEditorMonthlyInterval,
  N as recurrenceEditorMonthlyRepeatEvery,
  b as recurrenceEditorMonthlyRepeatOn,
  Q as recurrenceEditorOffsetPositionsFirst,
  _ as recurrenceEditorOffsetPositionsFourth,
  $ as recurrenceEditorOffsetPositionsLast,
  U as recurrenceEditorOffsetPositionsSecond,
  X as recurrenceEditorOffsetPositionsThird,
  q as recurrenceEditorRepeat,
  ee as recurrenceEditorWeekdaysDay,
  re as recurrenceEditorWeekdaysWeekday,
  te as recurrenceEditorWeekdaysWeekendday,
  P as recurrenceEditorWeeklyInterval,
  Y as recurrenceEditorWeeklyRepeatEvery,
  I as recurrenceEditorWeeklyRepeatOn,
  z as recurrenceEditorYearlyInterval,
  L as recurrenceEditorYearlyOf,
  x as recurrenceEditorYearlyRepeatEvery,
  j as recurrenceEditorYearlyRepeatOn,
  E as showFullDay,
  h as showWorkDay,
  Te as timeTitle,
  c as timelineViewTitle,
  t as today,
  n as weekViewTitle,
  o as workWeekViewTitle
};
